import { render } from "./FeedbackModal.vue?vue&type=template&id=c21d0d94&ts=true&lang=html"
import script from "./FeedbackModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./FeedbackModal.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__